import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Box, Typography } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        marginTop: theme.spacing(4),
    },
    logoContainer: {
        marginBottom: theme.spacing(16),
    },
    title: {
        fontWeight: 500,
        marginBottom: theme.spacing(8),
    },
    description: {
        color: theme.palette.emteria.text.primary,
        fontWeight: 400,
        marginBottom: theme.spacing(6),
    },
    emailText: {
        fontWeight: 500,
        color: theme.palette.emteria.text.primary,
    },
    actionContainer: {
        marginTop: theme.spacing(5),
    },
    loginLink: {
        color: theme.palette.emteria.link,
        textDecoration: "none",
    },
}));

type RegistrationSuccessProps = {
    email: string;
};

const RegistrationSuccess = ({ email }: RegistrationSuccessProps) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);

    return (
        <Box className={classes.container}>
            <Typography variant="h5" className={classes.title}>
                {t("pages:registerPage.success.title")}
            </Typography>
            <Typography className={classes.description}>{t("pages:registerPage.success.description", { email })}</Typography>
            <Typography className={classes.actionContainer}>{t("pages:registerPage.success.noEmail")}</Typography>
        </Box>
    );
};

export default RegistrationSuccess;
